class LightBoxVideo {
  constructor() {
    this.videos = {};
    this.lightBoxVideo();
  }

  lightBoxVideo = () => {
    this.setEvents();
    this.setMutationObserver();
  }

  setMutationObserver = () => {
    const observer = new MutationObserver(mutation => {
      const imageMutations = mutation.filter((m) => {
        return m.attributeName === "src" && m.target.className === 'lb-image'
      });

      const overlayDisplay = window.getComputedStyle(document.querySelector('.lightboxOverlay'), null).display;
      if ("none" === overlayDisplay) {
        this.closeLightboxVideo(true);
      }

      if (imageMutations.length > 0) {
        if (this.videos[imageMutations[0].target.src]) {
          this.playLightboxVideo(this.videos[imageMutations[0].target.src]);
        }
      }
    });

    observer.observe(document.body, {
      childList: false,
      attributes: true,
      subtree: true,
      characterData: false
    });
  }

  setEvents = () => {
    $('a[data-lightbox-video]').on('click', (e) => {
      e.preventDefault();
      this.playLightboxVideo($(e.currentTarget));
    });
  }

  closeLightboxVideo = () => {
    const lightbox = $('.lightbox');
    const container = lightbox.find('.lb-container');
    const video = container.find('video');

    setTimeout(() => {
      if(!lightbox.is(':visible') && video.length > 0) {
        const id = $(video).attr('id');
        $('#'+id).trigger('play');

        video.remove();

        lightbox.removeClass('lightbox-video');
      }
    }, 250);
  }

  playLightboxVideo = (element) => {
    this.closeLightboxVideo();

    $(element).find('video').trigger('pause');

    const lightbox = $('.lightbox');
    const container = lightbox.find('.lb-container');
    const video = $(element).find('video').clone(false).trigger('play');
    container.prepend(video);
    container.find('.lb-loader').hide();

    lightbox.addClass('lightbox-video');
  }
}


window.addEventListener('DOMContentLoaded', () => {
  new LightBoxVideo();
});
